import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as cs from '../components/common/common-styles';
import { VerticalStepper } from '../components/common/vertical-stepper';
import { LabelledInput, MaskPhoneNumberInput } from '../components/common/info-form';
import { BackButton, ContinueButton } from '../components/common/navigation-buttons-v2';
import { TBID_FORM_KEYS } from '../components/common/constants';

const BUSINESS_LABEL = 'Business Name'

export function TbidContact(props) {
  const {
    payload,
    ownerFirstName,
    ownerLastName,
    handleNameChange,
    updatePayload,
    businessInfo,
  } = props;

  const history = useHistory();

  const [formPayload, setFormPayload] = useState(payload || {});

  const handleFormUpdate = useCallback((key, data) => {
    setFormPayload(formPayload => ({ ...formPayload, [key]: data }));
  }, [setFormPayload, ownerFirstName, ownerLastName]);

  const handleForwardClick = useCallback(() => {
    updatePayload({
      ...formPayload,
      [TBID_FORM_KEYS.ownerFullName]: `${ownerFirstName} ${ownerLastName}`,
    });

    history.push('/payment');
  }, [history, updatePayload, formPayload, ownerFirstName, ownerLastName]);

  return (
    <VerticalStepper activeStep={3}>
      <cs.Form onSubmit={handleForwardClick}>
        <cs.HeaderText style={{ paddingBottom: '0px', marginBottom: '40px' }}>
          Please provide contact information so we can send you the receipt for your assessment.
        </cs.HeaderText>

        <div style={{ marginBottom: '26px' }}>
          <cs.InputTextFieldLabel style={{ marginBottom: '13px' }}>{BUSINESS_LABEL}</cs.InputTextFieldLabel>
          {/* TODO: Add real data here for business name */}
          <cs.BoldedLabel bold>{businessInfo.registrantName}</cs.BoldedLabel>
        </div>

        <cs.SideBySideInputWrapper>
          <LabelledInput
            label="First Name"
            name={TBID_FORM_KEYS.ownerFirstName}
            value={ownerFirstName}
            onChange={handleNameChange}
            maxLength={100}
            required={true}
            width="180px"
            noMargin
          />
          <LabelledInput
            label="Last Name"
            name={TBID_FORM_KEYS.ownerLastName}
            value={ownerLastName}
            onChange={handleNameChange}
            maxLength={100}
            required={true}
            width="180px"
            noMargin
          />
        </cs.SideBySideInputWrapper>

        <LabelledInput
          type="email"
          label="Email"
          name={TBID_FORM_KEYS.ownerEmail}
          value={formPayload.ownerEmail}
          onChange={(e) => handleFormUpdate(TBID_FORM_KEYS.ownerEmail, e.target.value)}
          pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$"
          maxLength={200}
          required={true}
        />

        <LabelledInput
          label="Your Title (Optional)"
          name={TBID_FORM_KEYS.ownerTitle}
          value={formPayload.ownerTitle}
          onChange={(e) => handleFormUpdate(TBID_FORM_KEYS.ownerTitle, e.target.value)}
          maxLength={200}
        />

        <MaskPhoneNumberInput
          type="tel"
          label="Phone Number (Optional)"
          name={TBID_FORM_KEYS.ownerPhone}
          value={formPayload.ownerPhone}
          onChange={(value) => handleFormUpdate(TBID_FORM_KEYS.ownerPhone, value)}
          customInput={LabelledInput}
          pattern={"[0-9]{3}-[0-9]{3}-[0-9]{4}"}
        />

        <cs.ButtonWrapper>
          <BackButton />
          <ContinueButton isDisabled={!ownerFirstName || !ownerLastName || !formPayload.ownerEmail}/>
        </cs.ButtonWrapper>
      </cs.Form>
    </VerticalStepper>
  );
}
